import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { OutlinedInput, outlinedInputClasses } from '@mui/material';

const DatePicker = ({ className, name, minDOBirth, maxDOBirth, value, fromDate, toDate, callBackFun }) => {
  const TextFieldComponent = (props) => {
    return <TextField {...props} disabled={true} />
  }
  const [val, setVal] = useState(value);
  return (
    <DatePickerWrapper className={className}>
      <div className='custom-date-piker'>
        <div
          className='file-input-wrapper'
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              minDate={minDOBirth}
              maxDate={maxDOBirth}
              disabled={false}
              name={name}
              margin="normal"
              id="date-picker-dialog"
              format="MM/dd/yyyy"
              placeholder="MM/DD/YYYY"
              value={val}
              onChange={(date) => {
                // let offsetTime = new Date().getTimezoneOffset()
                // var newDate = new Date(date.getTime() + (offsetTime * 60 * 1000));
                setVal(date)
                return callBackFun(date);
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              invalidDateMessage="Invalid date"
              minDateMessage="Invalid date"
              maxDateMessage="Invalid date"
            // TextFieldComponent={TextFieldComponent}
            />

          </MuiPickersUtilsProvider>

        </div>
      </div>

    </DatePickerWrapper>
  );
};

export default DatePicker;
const DatePickerWrapper = styled.div`
  .MuiFormControl-marginNormal {
    margin: 0;
  }
  .MuiInputBase-input {
    padding: 2px 8px;
    font-size: 14px;
      }
      .MuiInputBase-root {
        border: 1px solid #e0e0e0;
       border-radius: 6px;
      }
      .MuiInput-underline:before {
        border: none;
      }
      &.responsive {
        .MuiInputBase-input {
        /* padding: 12px 0 13px; */
        font-size: clamp(10px,0.729vw,14px);
}.MuiSvgIcon-root {
    width: clamp(18px,1.25vw,24px);
    height: clamp(18px,1.25vw,24px);
}
.MuiInputBase-root {
height: clamp(38px,2.292vw,44px);
      }
      }
`
